import React, { Component } from 'react';
import Loading from '../assets/loading.gif';
import classie from './js/classie.js';
import $ from 'jquery';

import 'jquery-ui-bundle';
import 'jquery-ui-bundle/jquery-ui.css';

import './css/Style.css';
import './css/normalize.css';
import './css/demo.css';
import './css/component.css';

class Index extends Component {
  componentDidMount() {
    const { geocode, cor } = this.props.match.params;
    var api_baseUrl = 'https://apiprevmet3.inmet.gov.br'; 
    var isMenuOpen = false;

    var areas = [
      {'sigla' : 'capitais',   'nome' : 'Capitais'},
      {'sigla' : 'municipios', 'nome' : 'Municípios/Turnos'},
    ];

    var municipio = {
      'id': 'Brasília-DF',
      'label': 'Brasília/DF',
      'value': 'Brasília/DF',
      'custom': 'DF-Brasília',
      'geocode': 5300108,
      'lat': '-15.780672725660471',
      'lon': '-47.797189556089556'
    };

    function geraOptions(element, data, inicial = null, atributo_inicial = null) {
      var opt = document.createElement('option');
      
      for (var i = 0; i < data.length; i++) {
        opt = document.createElement('option');
        opt.value = data[i].sigla;
        opt.innerHTML = data[i].nome;

        if(inicial)
          if(atributo_inicial && data[i].sigla === atributo_inicial)
            opt.setAttribute('selected', 'selected');

        element.append(opt);
      }
    }

    async function init(){
      if(geocode){
        geraOptions($('.area'), areas, true, 'municipios');
        await $.get(`${api_baseUrl}/buscar/cidade/${geocode}`, function(response) {
          municipio = response[0];
        });
        $('.municipio')[0].style.setProperty('display', 'inline-block', 'important');
        $('#search').val(municipio.label);
      }else{
        $('.municipio')[0].style.setProperty('display', 'none', 'important');
        geraOptions($('.area'), areas, true, 'capitais');
      }
      $('.submit').click();
    }

    async function changeCor() {
      $('#gn-menu').css('background',`#${cor}`)

      $('select').css('background-color',`#${cor}`)
      $('input').css('background-color',`#${cor}`)

      $('.previsaoList > .validades > span.active').css('background',`#${cor}`)
      $('.submit').css('background-color',`#${cor}`)
    }

    $(document).ready(async function() {
      init();

      if(cor) {
        await changeCor()
      }

      $('.tablinks').addClass('active');
      $('.tab-content').addClass('active');
    });

    $(function () {
      $('#search').autocomplete({
        minLength: 2,
        maxResults: 20,
        source: function (request, response){
          $.ajax({
            url: `${api_baseUrl}/autocomplete/${request.term}`,
            dataType: "json",
            success: response,
            error: function () {
              response([]);
            }
          });
        },
        select: function( event, ui ) {
          event.preventDefault();
          $('label[for="local"] strong').html(decodeURIComponent(ui.item.value.replace(/\+/g, ' ')));
          $('#search').val('Aguarde...');
          municipio = ui.item;
          $('#search').val(municipio.label);
        }
      }).autocomplete('instance')._renderItem = function( ul, item ) {
        return $('<li>')
          .append('<div>' + decodeURIComponent(item.label.replace(/\+/g, ' ')) + '</div>')
          .appendTo(ul);
      };
    });

    $('.input').keypress(function (e) {
      return false;
    });

    $('.area').change(function() {
      let area = $('.area').val();
      if(area.includes('municipio')) {
        $('.municipio')[0].style.setProperty('display', 'inline-block', 'important');
        $('#search').val(municipio.label);
      } else {
        $('.municipio')[0].style.setProperty('display', 'none', 'important');
      }
    });

    $('.submit').click(function(e) {
      let area  = $('.area').val();

      classie.remove( document.getElementById('menu'), 'gn-selected' );
      classie.remove( document.getElementById('wrapper'), 'gn-open-all' );
      isMenuOpen = false;
      
      $('.conteudoWrapper').css('display', 'none');
      $('.img').css('display', 'block');
      $('.img').attr('src', Loading);
      
      $('.conteudoWrapper').empty();

      if(area.includes('municipio') && municipio){
        $.get(`${api_baseUrl}/previsao/${municipio.geocode}`, function(response) {
          let i = 0;
          let horarios = ['manha', 'tarde', 'noite'];
          let horariosLabel = ['Manhã', 'Tarde', 'Noite'];

          for(var data in response[municipio.geocode]) {
            if(i < 2) {
              let temp_max = Math.max.apply(Math, [
                parseFloat(response[municipio.geocode][data]['manha']['temp_max']),
                parseFloat(response[municipio.geocode][data]['tarde']['temp_max']),
                parseFloat(response[municipio.geocode][data]['noite']['temp_max']),
              ])

              let temp_min = Math.min.apply(Math, [
                parseFloat(response[municipio.geocode][data]['manha']['temp_min']),
                parseFloat(response[municipio.geocode][data]['tarde']['temp_min']),
                parseFloat(response[municipio.geocode][data]['noite']['temp_min']),
              ])

              let umi_max = Math.max.apply(Math, [
                parseFloat(response[municipio.geocode][data]['manha']['umidade_max']),
                parseFloat(response[municipio.geocode][data]['tarde']['umidade_max']),
                parseFloat(response[municipio.geocode][data]['noite']['umidade_max']),
              ])

              let umi_min = Math.min.apply(Math, [
                parseFloat(response[municipio.geocode][data]['manha']['umidade_min']),
                parseFloat(response[municipio.geocode][data]['tarde']['umidade_min']),
                parseFloat(response[municipio.geocode][data]['noite']['umidade_min']),
              ])

              $('.conteudoWrapper').append(`
                <section class="grid grid-template-columns-2 no-border align-left">
                  <div class="item"><font size="5"><b>${municipio.label.replace('-', ', ')} - ${data.replace(/-/g, '/')} - ${response[municipio.geocode][data]['manha']['dia_semana']}</b></font></div>
                </section>
                <br />

                <section class="grid grid-template-columns-4">
                  <div class="item">Temperatura Mínima <br /> <font size="3" color="blue">${temp_min}°C</font><br/><font size="3">Tendência:</font> <img title="${response[municipio.geocode][data]['manha']['temp_min_tende']}" src="${response[municipio.geocode][data]['manha']['temp_min_tende_icone']}" width="15px" height="15px"/></div>
                  <div class="item">Temperatura Máxima <br /> <font size="3" color="red">${temp_max}°C</font><br/><font size="3">Tendência:</font> <img title="${response[municipio.geocode][data]['manha']['temp_max_tende']}" src="${response[municipio.geocode][data]['manha']['temp_max_tende_icone']}" width="15px" height="15px"/></div>
                  <div class="item">Umidade Máxima <br /> <font size="3" color="blue">${umi_max}%</font></div>
                  <div class="item">Umidade Mínima <br /> <font size="3" color="red">${umi_min}%</font></div>
                </section>
              `);
              $('.conteudoWrapper').append(`<section id="row-${i+1}" class="grid grid-template-columns-3 no-border"></section>`);
              for(let j = 0; j < horarios.length; j++){
                $(`#row-${i+1}`).append(`
                  <div class="item">
                    <section class="grid grid-template-columns-1 no-border">
                      <div class="item"><font size="3"><b>${horariosLabel[j]}</b></font></div>
                    </section>
                    <div class="grid grid-template-columns-2-minmax no-border">
                      <div class="item"><img src="${response[municipio.geocode][data][horarios[j]]['icone']}" /></div>
                      <div class="item"><font size="3">:: ${response[municipio.geocode][data][horarios[j]]['resumo']} ${response[municipio.geocode][data][horarios[j]]['tempo']}</font></div>
                    </div>
                    <section class="grid grid-template-columns-2 no-border">
                      <div class="item"><font size="2"><b>Direção do Vento</b></font> <br /> <font size="2" color="#595959">${response[municipio.geocode][data][horarios[j]]['dir_vento']}</font></div>
                      <div class="item"><font size="2"><b>Intensidade do Vento</b></font> <br /> <font size="2" color="#595959">${response[municipio.geocode][data][horarios[j]]['int_vento']}</font></div>
                    </section>
                  </div>
                `);
              }
              // $('.conteudoWrapper').append(`${response[municipio.geocode][data]['tarde']['fonte'] === 'modelo' ? '<br /><section class="grid grid-template-columns-1"><div class="item"><font color="red">*Dado proveniente de modelo numérico</font></div></section>' : ''}`);
            } else {
              $('.conteudoWrapper').append(`<div class=row-${i+1}>`);
              $(`.row-${i+1}`).append(`
                <section class="grid grid-template-columns-1 no-border align-left">
                  <div class="item"><font size="5"><b>${municipio.label} - ${data.replace(/-/g, '/')} - ${response[municipio.geocode][data]['dia_semana']}</b></font></div>
                </section>

                <section class="grid grid-template-columns-2-minmax no-border align-left">
                  <div class="item"><img src="${response[municipio.geocode][data]['icone']}" /></div>
                  <div class="item"><font size="3">:: ${response[municipio.geocode][data]['resumo']} ${response[municipio.geocode][data]['tempo']}</font></div>

                </section>

                <section class="grid grid-template-columns-4">
                  <div class="item">Temperatura Mínima <br /> <font size="3" color="blue">${response[municipio.geocode][data]['temp_min']}°C</font><br/><font size="3">Tendência:</font> <img title="${response[municipio.geocode][data]['temp_min_tende']}" src="${response[municipio.geocode][data]['temp_min_tende_icone']}" width="15px" height="15px"/></div>
                  <div class="item">Temperatura Máxima <br /> <font size="3" color="red">${response[municipio.geocode][data]['temp_max']}°C</font><br/><font size="3">Tendência:</font> <img title="${response[municipio.geocode][data]['temp_max_tende']}" src="${response[municipio.geocode][data]['temp_max_tende_icone']}" width="15px" height="15px"/></div>
                  <div class="item">Umidade Máxima <br /> <font size="3" color="blue">${response[municipio.geocode][data]['umidade_max']}%</font></div>
                  <div class="item">Umidade Mínima <br /> <font size="3" color="red">${response[municipio.geocode][data]['umidade_min']}%</font></div>
                </section>
                <br />

                <section class="grid grid-template-columns-2">
                  <div class="item">Direção do Vento <br /> <font size="3" color="#595959">${response[municipio.geocode][data]['dir_vento']}</font></div>
                  <div class="item">Intensidade do Vento <br /> <font size="3" color="#595959">${response[municipio.geocode][data]['int_vento']}</font></div>
                </section>
                <br />

              `);
            }
            // ${response[municipio.geocode][data]['fonte'] === 'modelo' ? '<br /><section class="grid grid-template-columns-1"><div class="item"><font color="red">*Dado proveniente de modelo numérico</font></div></section>' : ''}

            $('.conteudoWrapper').append('<hr />');
            i++;
          }
        });
        $('.img').css('display', 'none');
        $('.conteudoWrapper').css('display', 'block');
      } else if(area.includes('capitais')) {
        $.get(`${api_baseUrl}/previsao/capitais`, function(response) {
          let i = 0;
          let horarios = ['manha', 'tarde', 'noite'];
          let horariosLabel = ['Manhã', 'Tarde', 'Noite'];

          $('.conteudoWrapper').append('<div class="tab">');
          for(let keyPai in response) {
            $('.tab').append(`<button class="tablinks" onclick="javascript:tabClick(event, '${keyPai.replace(/ /g, '-')}')">${keyPai}</button>`);
            $('.conteudoWrapper').append(`<div id="${keyPai.replace(/ /g, '-')}" class="tabcontent">`);
            i = 0
            for(let data in response[keyPai]) {
              if(i <= 1) {
                let temp_max = Math.max.apply(Math, [
                  parseFloat(response[keyPai][data]['manha']['temp_max']),
                  parseFloat(response[keyPai][data]['tarde']['temp_max']),
                  parseFloat(response[keyPai][data]['noite']['temp_max']),
                ])
      
                let temp_min = Math.min.apply(Math, [
                  parseFloat(response[keyPai][data]['manha']['temp_min']),
                  parseFloat(response[keyPai][data]['tarde']['temp_min']),
                  parseFloat(response[keyPai][data]['noite']['temp_min']),
                ])
      
                let umi_max = Math.max.apply(Math, [
                  parseFloat(response[keyPai][data]['manha']['umidade_max']),
                  parseFloat(response[keyPai][data]['tarde']['umidade_max']),
                  parseFloat(response[keyPai][data]['noite']['umidade_max']),
                ])
      
                let umi_min = Math.min.apply(Math, [
                  parseFloat(response[keyPai][data]['manha']['umidade_min']),
                  parseFloat(response[keyPai][data]['tarde']['umidade_min']),
                  parseFloat(response[keyPai][data]['noite']['umidade_min']),
                ])
      
                $(`#${keyPai.replace(/ /g, '-')}`).append(`
                  <section class="grid grid-template-columns-2 no-border align-left">
                    <div class="item"><font size="5"><b>${keyPai}, ${response[keyPai][data]['manha']['uf']} - ${data}</b></font></div>
                  </section>
                  <br />
      
                  <section class="grid grid-template-columns-4">
                    <div class="item">Temperatura Mínima <br /> <font size="3" color="blue">${temp_min}°C</font><br/><font size="3">Tendência:</font> <img title="${response[keyPai][data]['manha']['temp_min_tende']}" src="${response[keyPai][data]['manha']['temp_min_tende_icone']}" width="15px" height="15px"/></div>
                    <div class="item">Temperatura Máxima <br /> <font size="3" color="red">${temp_max}°C</font><br/><font size="3">Tendência:</font> <img title="${response[keyPai][data]['manha']['temp_max_tende']}" src="${response[keyPai][data]['manha']['temp_max_tende_icone']}" width="15px" height="15px"/></div>
                    <div class="item">Umidade Máxima <br /> <font size="3" color="blue">${umi_max}%</font></div>
                    <div class="item">Umidade Mínima <br /> <font size="3" color="red">${umi_min}%</font></div>
                  </section>
                `);

                $(`#${keyPai.replace(/ /g, '-')}`).append(`<section id="row-${i+1}-${keyPai.replace(/ /g, '-')}" class="grid grid-template-columns-3 no-border"></section>`);
                for(let j = 0; j < horarios.length; j++) {
                  $(`#row-${i+1}-${keyPai.replace(/ /g, '-')}`).append(`
                    <div class="item">
                      <section class="grid grid-template-columns-1 no-border">
                          <div class="item"><font size="3"><b>${horariosLabel[j]}</b></font></div>
                      </section>
                    
                      <div class="grid grid-template-columns-2-minmax no-border">
                        <div class="item"><img src="${response[keyPai][data][horarios[j]]['icone']}" /></div>
                        <div class="item"><font size="3">:: ${response[keyPai][data][horarios[j]]['resumo']} ${response[keyPai][data][horarios[j]]['tempo']}</font></div>
                      </div>
      
                      <section class="grid grid-template-columns-2 no-border">
                        <div class="item"><font size="2"><b>Direção do Vento</b></font> <br /> <font size="2" color="#595959">${response[keyPai][data][horarios[j]]['dir_vento']}</font></div>
                        <div class="item"><font size="2"><b>Intensidade do Vento</b></font> <br /> <font size="2" color="#595959">${response[keyPai][data][horarios[j]]['int_vento']}</font></div>
                      </section>
                    </div>
                  `);
                }
                // $(`#${keyPai.replace(/ /g, '-')}`).append(`${response[keyPai][data]['tarde']['fonte'] === 'modelo' ? '<br /><section class="grid grid-template-columns-1"><div class="item"><font color="red">*Dado proveniente de modelo numérico</font></div></section>' : ''}`);
                $(`#${keyPai.replace(/ /g, '-')}`).append('<hr />')
              } else {
                $(`#${keyPai.replace(/ /g, '-')}`).append(`
                  <section class="grid grid-template-columns-2 no-border align-left">
                    <div class="item"><font size="5"><b>${data}</b></font></div>
                  </section>
                  <br />
                  
                  <section class="grid grid-template-columns-2-minmax no-border align-left">
                    <div class="item"><img src="${response[keyPai][data]['icone']}" /></div>
                    <div class="item"><font size="3">:: ${response[keyPai][data]['resumo']} ${response[keyPai][data]['tempo']}</font></div>
                    </section>
      
                  <section class="grid grid-template-columns-4">
                    <div class="item">Temperatura Mínima <br /> <font size="3" color="blue">${response[keyPai][data]['temp_min']}°C</font><br/><font size="3">Tendência:</font> <img title="${response[keyPai][data]['temp_min_tende']}" src="${response[keyPai][data]['temp_min_tende_icone']}" width="15px" height="15px"/></div>
                    <div class="item">Temperatura Máxima <br /> <font size="3" color="red">${response[keyPai][data]['temp_max']}°C</font><br/><font size="3">Tendência:</font> <img title="${response[keyPai][data]['temp_max_tende']}" src="${response[keyPai][data]['temp_max_tende_icone']}" width="15px" height="15px"/></div>
                    <div class="item">Umidade Máxima <br /> <font size="3" color="blue">${response[keyPai][data]['umidade_max']}%</font></div>
                    <div class="item">Umidade Mínima <br /> <font size="3" color="red">${response[keyPai][data]['umidade_min']}%</font></div>
                  </section>
                  <br />
      
                  <section class="grid grid-template-columns-2">
                    <div class="item">Direção do Vento <br /> <font size="3" color="#595959">${response[keyPai][data]['dir_vento']}</font></div>
                    <div class="item">Intensidade do Vento <br /> <font size="3" color="#595959">${response[keyPai][data]['int_vento']}</font></div>
                  </section>
                  <br />
      
                  <hr />
                `);
                // ${response[keyPai][data]['fonte'] === 'modelo' ? '<br /><section class="grid grid-template-columns-1"><div class="item"><font color="red">*Dado proveniente de modelo numérico</font></div></section>' : ''}
              }
              i++
            }

          }

          $('.tablinks').first().addClass('active');
          $('.tabcontent').first().css('display', 'block');
          
          $('.img').css('display', 'none');
          $('.conteudoWrapper').css('display', 'block');
        });
      }
    });

    // ========== INICIO MENU LATERAL ==========
    function mobilecheck() {
      var check = false;
      // eslint-disable-next-line
      (function(a){if(/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }
  
    function gnMenu( el, options ) {	
      this.el = el;
      this._init();
    }

    gnMenu.prototype = {
      _init : function() {
        this.trigger = this.el.querySelector( 'a.gn-icon-menu' );
        this.menu = this.el.querySelector( 'nav.gn-menu-wrapper' );
        isMenuOpen = false;
        this.eventtype = mobilecheck() ? 'touchstart' : 'click';
        this._initEvents();
  
        var self = this;
        this.bodyClickFn = function() {
          self._closeMenu();
          this.removeEventListener( self.eventtype, self.bodyClickFn );
        };
      },
      _initEvents : function() {
        var self = this;
  
        if( !mobilecheck() ) {
          this.menu.addEventListener( 'mouseover', function(ev) {
            self._openMenu(); 
            document.addEventListener( self.eventtype, self.bodyClickFn ); 
          } );
        }
        this.trigger.addEventListener( this.eventtype, function( ev ) {
          ev.stopPropagation();
          ev.preventDefault();
          if( isMenuOpen ) {
            self._closeMenu();
            document.removeEventListener( self.eventtype, self.bodyClickFn );
          }
          else {
            self._openMenu();
            document.addEventListener( self.eventtype, self.bodyClickFn );
          }
        } );
        this.menu.addEventListener( this.eventtype, function(ev) { ev.stopPropagation(); } );
      },
      _openIconMenu : function() {
        classie.add( this.menu, 'gn-open-part' );
      },
      _closeIconMenu : function() {
        classie.remove( this.menu, 'gn-open-part' );
      },
      _openMenu : function() {
        if( isMenuOpen ) return;
        classie.add( this.trigger, 'gn-selected' );
        isMenuOpen = true;
        classie.add( this.menu, 'gn-open-all' );
        this._closeIconMenu();
      },
      _closeMenu : function() {
        if( !isMenuOpen ) return;
        classie.remove( this.trigger, 'gn-selected' );
        isMenuOpen = false;
        classie.remove( this.menu, 'gn-open-all' );
        this._closeIconMenu();
      }
    }

    new gnMenu( document.getElementById( 'gn-menu' ) );
    // ========== FIM MENU LATERAL ==========
  }
    
  render() {
    return (
      <div className="App">
        <div className="container">
          <ul id="gn-menu" className="gn-menu-main">
            <li className="gn-trigger">
              {/* eslint-disable-next-line */}
              <a className="gn-icon-menu" id="menu">
                <span>Menu</span>
              </a>
              <nav className="gn-menu-wrapper" id="wrapper">
                <div className="gn-scroller">
                  <ul className="gn-menu">
                    <li><span>INMET :: Previsão</span></li>
                    <hr />
                    <li><span>Área: </span><select className="area"></select></li>
                    <li className="municipio"><span>Município:</span><input type="search" className="search" id="search" placeholder="Buscar Município" autoComplete="on" /></li>
                    <hr />
                    <li><button className="submit">Visualizar Previsão</button></li>
                  </ul>
                </div>
              </nav>
            </li>
            <li className="inmetName"><a href="https://portal.inmet.gov.br/">Instituto Nacional de Meteorologia</a></li>
          </ul>
          
          <div id="containerFullScreen">
            <div className="imgWrapper">
              <img className="img" alt=""/>
              <div className="conteudoWrapper scrollBox"></div>
            </div>
          </div>
        </div>
      </div>
      );
    }
  }
export default Index;
    
